import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { SelectorEspacioComponent } from '../views/SelectorEspacios/SelectorEspacio.component';
import { FormularioEspacioComponent } from '../formularios/FormularioEspacio.component';
import { Http } from '@angular/http';
import { DataGridModule } from 'primeng/primeng';
import { GrowlModule } from 'primeng/primeng';
import { MessagesModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/primeng';
import { FileUploadModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { TranslateModule, TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';
import { ImageCropperModule } from 'ngx-img-cropper';
import { RoleGuardService as RoleGuard } from '../providers/authentication/role-guard.service';
// import { ColorPickerModule } from 'primeng/primeng';
import { ColorPickerModule } from 'ngx-color-picker';
import {
	ButtonModule,
	DialogModule,
	ConfirmDialogModule,
	InputSwitchModule,
	TabMenuModule,
	DropdownModule,
} from 'primeng/primeng';
// import { SelectorIdiomaComponent } from '../componentes/selector-idioma/selector-idioma.component';

export const selectorEspacioModuleRoutes: Routes = [
	{
		path: 'espacios',
		component: SelectorEspacioComponent, // the `component` property is necessary when the lazy module provides some service in order to injection work well. If defined, the referenced component's template should have an element with the `<router-outlet>` directive.
		children: [
			{
				path: '',
				component: SelectorEspacioComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: undefined
				},
				pathMatch: 'full'
			 }
		]
	}
];

@NgModule({
	imports: [
		CalendarModule,
		InputSwitchModule,
		CommonModule,
		FormsModule,
		MessagesModule,
		RouterModule.forChild(selectorEspacioModuleRoutes),
		ButtonModule,
		InputSwitchModule,
		ColorPickerModule,
		ConfirmDialogModule,
		DataGridModule,
		DialogModule,
		DropdownModule,
		GrowlModule,
		ImageCropperModule,
		PanelModule,
		TableModule,
		FileUploadModule,
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
        })
	],

	declarations: [
		FormularioEspacioComponent,
		SelectorEspacioComponent
		// SelectorIdiomaComponent
	]

})

export class SelectorEspacioModule {

	static forRoot(): ModuleWithProviders {
		return {
		  ngModule: SelectorEspacioModule
		  // providers: [CreditCardService]
		};
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/selector.espacio.module.ts